/* eslint-disable import/prefer-default-export */
import { atom } from 'recoil';

export const loadingCounterAtom = atom({
  key: 'loadingCounterAtom',
  default: 0,
});
export const userDataAtom = atom({
  key: 'userDataAtom',
  default: null,
});
export const projectsDataAtom = atom({
  key: 'projectsDataAtom',
  default: null,
});
export const slideShowAtom = atom({
  key: 'slideShow',
  default: false,
});
export const readOnlyAtom = atom({
  key: 'readOnlyAtom',
  default: false,
});
export const enableChangesAtom = atom({
  key: 'enableChangesAtom',
  default: false,
});
export const showSwitchAtom = atom({
  key: 'showSwitchAtom',
  default: false,
});
export const openSaveChangesDialogAtom = atom({
  key: 'openSaveChangesDialogAtom',
  default: false,
});
export const selectedProjectNameAtom = atom({
  key: 'selectedProjectNameAtom',
  default: null,
});
export const selectedVersionAtom = atom({
  key: 'selectedVersionAtom',
  default: 0,
});
export const changesSendedAtom = atom({
  key: 'changesSendedAtom',
  default: false,
});
export const isChangedAtom = atom({
  key: 'isChangedAtom',
  default: false,
});
export const arrayChangesAtom = atom({
  key: 'arrayChangesAtom',
  default: [],
});
export const openProjectNameAtom = atom({
  key: 'openProjectNameAtom',
  default: null,
});
export const addNewPjAtom = atom({
  key: 'addNewPjAtom',
  default: false,
});
export const newProjectObjAtom = atom({
  key: 'newProjectObjAtom',
  default: {},
});
export const allPmsAtom = atom({
  key: 'allPmsAtom',
  default: null,
});
export const pgmAreasAtom = atom({
  key: 'pgmAreasAtom',
  default: null,
});
export const pgTypesAtom = atom({
  key: 'pgTypesAtom',
  default: null,
});
export const logoListAtom = atom({
  key: 'logoListAtom',
  default: [],
});
export const selectedLogoAtom = atom({
  key: 'selectLogoAtom',
  default: null,
});
export const blobLogoAtom = atom({
  key: 'blobLogoAtom',
  default: null,
});
export const mobileAtom = atom({
  key: 'mobileAtom',
  default: false,
});
export const logoUploadedAtom = atom({
  key: 'logoUploadedAtom',
  default: false,
});
export const editAtom = atom({
  key: 'editAtom',
  default: null,
});
export const newEditedPjAtom = atom({
  key: 'newEditedPjAtom',
  default: false,
});
export const logoToSetAtom = atom({
  key: 'logoToSetAtom',
  default: null,
});
export const utilisationsAtom = atom({
  key: 'utilisationsAtom',
  default: null,
});
export const openConfirmExitAtom = atom({
  key: 'openConfirmExitAtom',
  default: false,
});
